import React, {useEffect, useState} from "react";
import "./style.css";
import { FloatingContinueBtn } from "../../../../../components/FloatingContinueBtn";

export const MobileUserName = ({
    clickNext = () => {},
    clickPrev = () => {},
                                   userName,
                                   setUserName,
                                   onPageFocus, onPageKeyDown,isCurPage, inputRef
                            }) => {
  
  // 控制浮动按钮显示
  const [showFloatingBtn, setShowFloatingBtn] = useState(false);
  
  // 处理输入框聚焦
  const handleFocus = (e) => {
    setShowFloatingBtn(true);
    if (onPageFocus) onPageFocus(e);
  };
  
  // 处理输入框失焦
  const handleBlur = () => {
    setTimeout(() => {
      setShowFloatingBtn(false);
    }, 200);
  };
  
  // 处理浮动按钮点击
  const handleFloatingBtnClick = () => {
    if (userName) {
      // 隐藏键盘
      if (inputRef.current) inputRef.current.blur();
      setShowFloatingBtn(false);
      // 触发提交
      clickNext(userName);
    }
  };

  return (
    <div className="user-name-mobile" data-model-id="16762:23851">
      <FloatingContinueBtn 
        show={showFloatingBtn} 
        allow={!!userName}
        onClick={handleFloatingBtnClick}
      />
      <div className="div">
        <div className="title">
          <div className="heading">What's your name</div>
        </div>

        <div className="list-wrapper">
          <div className="list">
            <div className="date-picker">
                <input ref={inputRef} className="email-input"
                       enterKeyHint="done"
                       readOnly={!isCurPage}
                       onFocus={handleFocus}
                       onBlur={handleBlur}
                       onKeyDown={onPageKeyDown}
                       placeholder={"Enter your Name"}
                       onChange={(e) => { setUserName(e.target.value)}} value={userName}
                />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};
